import Box from '@mui/material/Box'
import { Payment20Regular } from '@/components/Icon'
import PlanUsagePlanTierCard from './PlanUsagePlanTierCard'

export function PlanUsageCurrentPlanCard() {
  return (
    <Box sx={{ flex: { xs: '1 1 auto', md: '0 0 auto' }, width: { xs: '100%', md: 'min(360px, 34%)' }, maxWidth: { md: 380 }, minWidth: 0 }}>
      <PlanUsagePlanTierCard
        sectionAriaLabel="Current subscription plan"
        shellTitle="Current Plan"
        titleIcon={<Payment20Regular />}
        planName="Pro+"
        priceLine="$XX/mo"
        description="Resets on 12 June (30 days)"
        actionLabel="manage"
        onAction={() => {}}
      />
    </Box>
  )
}
